<template>
  <div>
    <div class="addBtn" @click="addQM">添加签名</div>
    <div class="kkk" id="kqqwe">
      <div class="drag-box" v-drag="{fun:greet,index:index}" v-for="(item,index) in boxList">{{item.ti}}</div>
    </div>
    <p>
      <span v-for="(item,index) in boxList" style="font-size: 14px;color: #000">
        名字:{{item.ti}}
        l:{{item.st.left}}
        t:{{item.st.top}}
      </span>
    </p>
  </div>
</template>
<script type="text/ecmascript-6">
  import Vue from 'vue'
  Vue.directive('drag',//自定义指令
    {bind:function (el, binding) {
      let oDrag = el;   //当前元素
      let self = this;  //上下文
      let oBox;
      setTimeout(function () {
        oBox = document.getElementById('kqqwe');
      },1);
      oDrag.onmousedown = function (e) {
        //鼠标按下，计算当前元素距离可视区的距离
        let oEvent = e || event;
        let disX = oEvent.clientX - oDrag.offsetLeft;
        let disY = oEvent.clientY - oDrag.offsetTop;
        let obj;
        document.onmousemove = function(ev){
          let oEvents = ev || event;
          let left = oEvents.clientX - disX;
          let top = oEvents.clientY - disY;
          left<=0 && (left = 0);
          top<=0 && (top = 0);
          left>=(oBox.offsetWidth - oDrag.offsetWidth) && (left = oBox.offsetWidth - oDrag.offsetWidth);
          top>=(oBox.offsetHeight - oDrag.offsetHeight) && (top = oBox.offsetHeight - oDrag.offsetHeight);
          oDrag.style.left = left +'px';
          oDrag.style.top = top +'px';
          obj= {left:(left+50),top:(top+50)}
        };
        document.onmouseup = function(){
          binding.value.fun(binding.value.index,obj)
          document.onmousemove=null;
          document.onmouseup=null;
        };
      };
    }}
  );
    export default {
      data(){
        return{
          boxList:[]
        }
      },
      methods:{
        addQM(){
          let obj =
            {
              st:{left:0,top:0},
              ti:'12dpkqwod3'
            }
          this.boxList.push(obj)
        },
        greet(index,obj){
          this.boxList[index].st =obj;
        }
      }
    }
</script>
<style type="text/less" lang="less" rel="stylesheet/less" scoped="scoped">
  .addBtn{
    width: 120px;
    line-height: 35px;
    color: #ffffff;
    background: #000;
    cursor: pointer;
    font-size: 12px;
  }
  .kkk{
    width: 500px;
    height: 500px;
    /*border: 1px solid #ccc;*/
    background: red;
    position: relative;
    margin: 0 auto;
    .drag-box{
      width:100px;
      height: 100px;
      background: #369;
      position: absolute;
      left:0;
      top:0;
      font-size: 12px;
      color: #ffffff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/fire/dragTest.vue